import { h } from "preact";

import { Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";

export default function AlertDialog(props) {
	const handleClose = () => {
		props.onClose();
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5">{props.state.params.title}</Typography>
			</DialogTitle>
			<DialogContent dividers>{props.state.params.body}</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="contained">
					Fermer
				</Button>
			</DialogActions>
		</Dialog>
	);
}
